import React from 'react';
import { SlDropdownMenu } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/input';
import { DATE_RANGE_OPTIONS, DateRangeValue, dateRangeLabelFromValue } from '../shared';

interface DateRangeDropdownProps {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
}

const DateRangeDropdown: React.FC<DateRangeDropdownProps> = ({ value, onChange }) => {
  const options = React.useMemo(() => DATE_RANGE_OPTIONS.map((opt) => ({ id: opt.value, label: opt.label })), []);

  return (
    <SlDropdownMenu
      options={options}
      defaultLabel={dateRangeLabelFromValue(value)}
      selectedId={value}
      onChange={(opt) => onChange(opt.id as DateRangeValue)}
      stacklineButtonProps={{ buttonSx: { width: '120px' } }}
    />
  );
};

export default DateRangeDropdown;

 